import $ from 'jquery'
import _ from 'lodash'
var queue=[]

function isVisible(dom,isLazy){
    var $dom=$(dom)
    var $window=$(window)
    var scrollY=$window.scrollTop()
    var top=$dom.offset().top
    var lazyHeight = isLazy ? 400 : 0;
    if(!$dom.is(":visible")){
        return false
    }
    if(!(top-scrollY-lazyHeight<$window.height())||!(top-scrollY+$(dom).height()+lazyHeight>0)){
        return false
    }
    return true
}

function checkVisibleChange(){
    var remain=[]
    for(let i=0;i<queue.length;i++){
        if(isVisible(queue[i].dom)){
            queue[i].resolve()
        }else{
            remain.push(queue[i])
        }
    }
    queue=remain
}
var _checkVisibleChange=_.debounce(checkVisibleChange,50)

$(window).on('click',_checkVisibleChange)
$(window).on('resize',_checkVisibleChange)
$(window).on("scroll",_checkVisibleChange)

export {
    _checkVisibleChange
}

export default function(dom,isLazy){
    isLazy = isLazy || true;
    if(!dom||isVisible(dom,isLazy))return
    var p=new Promise(resolve=>{
        queue.push({
            dom,
            resolve
        })
    })
    return p
}